import { useContext, useEffect, useRef } from 'react';
import DeviceContext from '~/contexts/DeviceContext';
import ModalContext from '~/contexts/ModalContext';

export default function useModalScrollRestoration() {
  const {
    deviceData: { isDesktop }
  } = useContext(DeviceContext);
  const { isAnyModalOpen } = useContext(ModalContext);
  const scrollPositionRef = useRef<number>();

  // .no-scroll class doesn't prevent body scrolling on some mobile devices
  // so we need to manually save and restore scroll position
  useEffect(() => {
    if (isDesktop) return;

    if (isAnyModalOpen) {
      scrollPositionRef.current = window.scrollY;
    } else if (scrollPositionRef.current !== undefined) {
      if (scrollPositionRef.current !== window.scrollY) {
        window.scrollTo({
          top: scrollPositionRef.current,
          behavior: 'instant'
        });
      }
      scrollPositionRef.current = undefined;
    }
  }, [isAnyModalOpen]);
}
